import { render, staticRenderFns } from "./EventLog.vue?vue&type=template&id=08c85b67&"
import script from "./EventLog.vue?vue&type=script&lang=js&"
export * from "./EventLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports